.fixed-price-toggle {
	float: right;
	text-align: right;
  margin-top: -12px;
}
.fixed-price-toggle h2 {
	margin-bottom: 12px;
}
.fixed-price-toggle.loading {
	background-image: url(/static/img/ajax-loader-white-bg.gif);
  background-repeat: no-repeat;
  background-position: 0 26px;
  background-size: 24px;
  padding-left: 20px;
}
